import Footer from './Footer'
import Animation from './Animation'
import Logo from './Logo'
import Menu from './Menu'
import Social from '@/components/Social'

export { Animation, Logo, Menu, Social }

export default Footer
